import { Badge } from "@babackapp/ui/components/badge";

type QuickFilterCountBadgeProps = {
  count?: number;
};

export default function QuickFilterCountBadge({
  count,
}: QuickFilterCountBadgeProps) {
  if (!count) return null;

  return <Badge size="sm">{count > 999 ? "999+" : count}</Badge>;
}
